export default {
  lang: {
    common: [
      { key: "93", value: "93" },
      { key: "355", value: "355" },
      { key: "213", value: "213" },
      { key: "1684", value: "1684" },
      { key: "376", value: "376" },
      { key: "244", value: "244" },
      { key: "1264", value: "1264" },
      { key: "0672", value: "antar" },
      { key: "1268", value: "1268" },
      { key: "54", value: "54" },
      { key: "374", value: "374" },
      { key: "297", value: "297" },
      { key: "061", value: "aus" },
      { key: "43", value: "43" },
      { key: "994", value: "994" },
      { key: "1242", value: "1242" },
      { key: "973", value: "973" },
      { key: "880", value: "880" },
      { key: "1246", value: "1246" },
      { key: "375", value: "375" },
      { key: "32", value: "32" },
      { key: "501", value: "501" },
      { key: "229", value: "229" },
      { key: "1441", value: "1441" },
      { key: "975", value: "975" },
      { key: "591", value: "591" },
      { key: "387", value: "387" },
      { key: "267", value: "267" },
      { key: "55", value: "55" },
      { key: "246", value: "246" },
      { key: "673", value: "673" },
      { key: "359", value: "359" },
      { key: "226", value: "226" },
      { key: "257", value: "257" },
      { key: "855", value: "855" },
      { key: "237", value: "237" },
      { key: "01", value: "can" },
      { key: "238", value: "238" },
      { key: "1345", value: "1345" },
      { key: "236", value: "236" },
      { key: "235", value: "235" },
      { key: "56", value: "56" },
      { key: "86", value: "86" },
      { key: "61", value: "61" },
      { key: "57", value: "57" },
      { key: "269", value: "269" },
      { key: "242", value: "242" },
      { key: "243", value: "243" },
      { key: "682", value: "682" },
      { key: "506", value: "506" },
      { key: "385", value: "385" },
      { key: "53", value: "53" },
      { key: "357", value: "357" },
      { key: "420", value: "420" },
      { key: "45", value: "45" },
      { key: "253", value: "253" },
      { key: "1767", value: "1767" },
      { key: "1809", value: "1809" },
      { key: "593", value: "593" },
      { key: "20", value: "20" },
      { key: "503", value: "503" },
      { key: "240", value: "240" },
      { key: "291", value: "291" },
      { key: "372", value: "372" },
      { key: "251", value: "251" },
      { key: "0500", value: "falk" },
      { key: "298", value: "298" },
      { key: "679", value: "679" },
      { key: "358", value: "358" },
      { key: "33", value: "33" },
      { key: "689", value: "689" },
      { key: "241", value: "241" },
      { key: "220", value: "220" },
      { key: "995", value: "995" },
      { key: "49", value: "49" },
      { key: "233", value: "233" },
      { key: "350", value: "350" },
      { key: "30", value: "30" },
      { key: "299", value: "299" },
      { key: "1473", value: "1473" },
      { key: "590", value: "590" },
      { key: "1671", value: "1671" },
      { key: "502", value: "502" },
      { key: "441481", value: "441481" },
      { key: "224", value: "224" },
      { key: "245", value: "245" },
      { key: "592", value: "592" },
      { key: "509", value: "509" },
      { key: "379", value: "379" },
      { key: "504", value: "504" },
      { key: "852", value: "852" },
      { key: "36", value: "36" },
      { key: "354", value: "354" },
      { key: "91", value: "91" },
      { key: "62", value: "62" },
      { key: "98", value: "98" },
      { key: "964", value: "964" },
      { key: "353", value: "353" },
      { key: "972", value: "972" },
      { key: "39", value: "39" },
      { key: "225", value: "225" },
      { key: "1876", value: "1876" },
      { key: "81", value: "81" },
      { key: "441534", value: "441534" },
      { key: "962", value: "962" },
      { key: "07", value: "kazak" },
      { key: "254", value: "254" },
      { key: "686", value: "686" },
      { key: "850", value: "850" },
      { key: "82", value: "82" },
      { key: "965", value: "965" },
      { key: "996", value: "996" },
      { key: "856", value: "856" },
      { key: "371", value: "371" },
      { key: "961", value: "961" },
      { key: "266", value: "266" },
      { key: "231", value: "231" },
      { key: "218", value: "218" },
      { key: "423", value: "423" },
      { key: "370", value: "370" },
      { key: "352", value: "352" },
      { key: "853", value: "853" },
      { key: "389", value: "389" },
      { key: "261", value: "261" },
      { key: "265", value: "265" },
      { key: "60", value: "60" },
      { key: "960", value: "960" },
      { key: "223", value: "223" },
      { key: "356", value: "356" },
      { key: "692", value: "692" },
      { key: "596", value: "596" },
      { key: "222", value: "222" },
      { key: "230", value: "230" },
      { key: "0262", value: "mayotte" },
      { key: "52", value: "52" },
      { key: "691", value: "691" },
      { key: "373", value: "373" },
      { key: "377", value: "377" },
      { key: "976", value: "976" },
      { key: "382", value: "382" },
      { key: "1664", value: "1664" },
      { key: "0212", value: "morocco" },
      { key: "258", value: "258" },
      { key: "95", value: "95" },
      { key: "264", value: "264" },
      { key: "674", value: "674" },
      { key: "977", value: "977" },
      { key: "31", value: "31" },
      { key: "599", value: "599" },
      { key: "687", value: "687" },
      { key: "64", value: "64" },
      { key: "505", value: "505" },
      { key: "227", value: "227" },
      { key: "234", value: "234" },
      { key: "683", value: "683" },
      { key: "672", value: "672" },
      { key: "1670", value: "1670" },
      { key: "047", value: "norway" },
      { key: "968", value: "968" },
      { key: "92", value: "92" },
      { key: "680", value: "680" },
      { key: "970", value: "970" },
      { key: "507", value: "507" },
      { key: "675", value: "675" },
      { key: "595", value: "595" },
      { key: "51", value: "51" },
      { key: "63", value: "63" },
      { key: "064", value: "pitcairn" },
      { key: "48", value: "48" },
      { key: "351", value: "351" },
      { key: "1787", value: "1787" },
      { key: "974", value: "974" },
      { key: "262", value: "262" },
      { key: "40", value: "40" },
      { key: "7", value: "7" },
      { key: "250", value: "250" },
      { key: "290", value: "290" },
      { key: "1869", value: "1869" },
      { key: "1758", value: "1758" },
      { key: "508", value: "508" },
      { key: "1784", value: "1784" },
      { key: "685", value: "685" },
      { key: "378", value: "378" },
      { key: "239", value: "239" },
      { key: "966", value: "966" },
      { key: "221", value: "221" },
      { key: "381", value: "381" },
      { key: "248", value: "248" },
      { key: "232", value: "232" },
      { key: "65", value: "65" },
      { key: "421", value: "421" },
      { key: "386", value: "386" },
      { key: "677", value: "677" },
      { key: "252", value: "252" },
      { key: "27", value: "27" },
      { key: "500", value: "500" },
      { key: "211", value: "211" },
      { key: "34", value: "34" },
      { key: "94", value: "94" },
      { key: "249", value: "249" },
      { key: "597", value: "597" },
      { key: "47", value: "47" },
      { key: "268", value: "268" },
      { key: "46", value: "46" },
      { key: "41", value: "41" },
      { key: "963", value: "963" },
      { key: "886", value: "886" },
      { key: "992", value: "992" },
      { key: "255", value: "255" },
      { key: "66", value: "66" },
      { key: "670", value: "670" },
      { key: "228", value: "228" },
      { key: "690", value: "690" },
      { key: "676", value: "676" },
      { key: "1868", value: "1868" },
      { key: "216", value: "216" },
      { key: "90", value: "90" },
      { key: "993", value: "993" },
      { key: "1649", value: "1649" },
      { key: "688", value: "688" },
      { key: "256", value: "256" },
      { key: "380", value: "380" },
      { key: "971", value: "971" },
      { key: "44", value: "44" },
      { key: "1", value: "1" },
      { key: "598", value: "598" },
      { key: "998", value: "998" },
      { key: "678", value: "678" },
      { key: "58", value: "58" },
      { key: "84", value: "84" },
      { key: "1284", value: "1284" },
      { key: "1340", value: "1340" },
      { key: "681", value: "681" },
      { key: "212", value: "212" },
      { key: "967", value: "967" },
      { key: "260", value: "260" },
      { key: "263", value: "263" }
    ],
    es: [
      { key: "93", value: "93" },
      { key: "355", value: "355" },
      { key: "49", value: "49" },
      { key: "376", value: "376" },
      { key: "244", value: "244" },
      { key: "1264", value: "1264" },
      { key: "672", value: "672" },
      { key: "1268", value: "1268" },
      { key: "599", value: "599" },
      { key: "966", value: "966" },
      { key: "213", value: "213" },
      { key: "54", value: "54" },
      { key: "374", value: "374" },
      { key: "297", value: "297" },
      { key: "61", value: "61" },
      { key: "43", value: "43" },
      { key: "994", value: "994" },
      { key: "1242", value: "1242" },
      { key: "880", value: "880" },
      { key: "1246", value: "1246" },
      { key: "973", value: "973" },
      { key: "32", value: "32" },
      { key: "501", value: "501" },
      { key: "229", value: "229" },
      { key: "1441", value: "1441" },
      { key: "375", value: "375" },
      { key: "95", value: "95" },
      { key: "591", value: "591" },
      { key: "387", value: "387" },
      { key: "267", value: "267" },
      { key: "55", value: "55" },
      { key: "673", value: "673" },
      { key: "359", value: "359" },
      { key: "226", value: "226" },
      { key: "257", value: "257" },
      { key: "975", value: "975" },
      { key: "238", value: "238" },
      { key: "855", value: "855" },
      { key: "237", value: "237" },
      { key: "974", value: "974" },
      { key: "235", value: "235" },
      { key: "56", value: "56" },
      { key: "86", value: "86" },
      { key: "357", value: "357" },
      { key: "57", value: "57" },
      { key: "269", value: "269" },
      { key: "242", value: "242" },
      { key: "82", value: "82" },
      { key: "225", value: "225" },
      { key: "506", value: "506" },
      { key: "385", value: "385" },
      { key: "53", value: "53" },
      { key: "45", value: "45" },
      { key: "1767", value: "1767" },
      { key: "593", value: "593" },
      { key: "20", value: "20" },
      { key: "503", value: "503" },
      { key: "971", value: "971" },
      { key: "291", value: "291" },
      { key: "421", value: "421" },
      { key: "386", value: "386" },
      { key: "34", value: "34" },
      { key: "1", value: "1" },
      { key: "372", value: "372" },
      { key: "251", value: "251" },
      { key: "63", value: "63" },
      { key: "358", value: "358" },
      { key: "679", value: "679" },
      { key: "33", value: "33" },
      { key: "241", value: "241" },
      { key: "220", value: "220" },
      { key: "995", value: "995" },
      { key: "233", value: "233" },
      { key: "350", value: "350" },
      { key: "1473", value: "1473" },
      { key: "30", value: "30" },
      { key: "299", value: "299" },
      { key: "590", value: "590" },
      { key: "1671", value: "1671" },
      { key: "502", value: "502" },
      { key: "441481", value: "441481" },
      { key: "224", value: "224" },
      { key: "240", value: "240" },
      { key: "245", value: "245" },
      { key: "592", value: "592" },
      { key: "509", value: "509" },
      { key: "504", value: "504" },
      { key: "852", value: "852" },
      { key: "36", value: "36" },
      { key: "91", value: "91" },
      { key: "62", value: "62" },
      { key: "964", value: "964" },
      { key: "98", value: "98" },
      { key: "353", value: "353" },
      { key: "262", value: "262" },
      { key: "354", value: "354" },
      { key: "1345", value: "1345" },
      { key: "682", value: "682" },
      { key: "298", value: "298" },
      { key: "500", value: "500" },
      { key: "1670", value: "1670" },
      { key: "692", value: "692" },
      { key: "677", value: "677" },
      { key: "1649", value: "1649" },
      { key: "1340", value: "1340" },
      { key: "1284", value: "1284" },
      { key: "972", value: "972" },
      { key: "39", value: "39" },
      { key: "1876", value: "1876" },
      { key: "81", value: "81" },
      { key: "441534", value: "441534" },
      { key: "962", value: "962" },
      { key: "254", value: "254" },
      { key: "996", value: "996" },
      { key: "686", value: "686" },
      { key: "383", value: "383" },
      { key: "965", value: "965" },
      { key: "266", value: "266" },
      { key: "371", value: "371" },
      { key: "961", value: "961" },
      { key: "231", value: "231" },
      { key: "218", value: "218" },
      { key: "423", value: "423" },
      { key: "370", value: "370" },
      { key: "352", value: "352" },
      { key: "853", value: "853" },
      { key: "389", value: "389" },
      { key: "261", value: "261" },
      { key: "60", value: "60" },
      { key: "265", value: "265" },
      { key: "960", value: "960" },
      { key: "223", value: "223" },
      { key: "356", value: "356" },
      { key: "212", value: "212" },
      { key: "596", value: "596" },
      { key: "230", value: "230" },
      { key: "222", value: "222" },
      { key: "52", value: "52" },
      { key: "691", value: "691" },
      { key: "373", value: "373" },
      { key: "377", value: "377" },
      { key: "976", value: "976" },
      { key: "382", value: "382" },
      { key: "1664", value: "1664" },
      { key: "258", value: "258" },
      { key: "264", value: "264" },
      { key: "674", value: "674" },
      { key: "977", value: "977" },
      { key: "505", value: "505" },
      { key: "227", value: "227" },
      { key: "234", value: "234" },
      { key: "683", value: "683" },
      { key: "47", value: "47" },
      { key: "687", value: "687" },
      { key: "64", value: "64" },
      { key: "968", value: "968" },
      { key: "31", value: "31" },
      { key: "92", value: "92" },
      { key: "680", value: "680" },
      { key: "970", value: "970" },
      { key: "507", value: "507" },
      { key: "675", value: "675" },
      { key: "595", value: "595" },
      { key: "51", value: "51" },
      { key: "689", value: "689" },
      { key: "48", value: "48" },
      { key: "351", value: "351" },
      { key: "1787", value: "1787" },
      { key: "44", value: "44" },
      { key: "963", value: "963" },
      { key: "236", value: "236" },
      { key: "420", value: "420" },
      { key: "82", value: "82" },
      { key: "243", value: "243" },
      { key: "856", value: "856" },
      { key: "1809", value: "1809" },
      { key: "255", value: "255" },
      { key: "250", value: "250" },
      { key: "40", value: "40" },
      { key: "7", value: "7" },
      { key: "685", value: "685" },
      { key: "1684", value: "1684" },
      { key: "1869", value: "1869" },
      { key: "378", value: "378" },
      { key: "1784", value: "1784" },
      { key: "508", value: "508" },
      { key: "1758", value: "1758" },
      { key: "290", value: "290" },
      { key: "239", value: "239" },
      { key: "221", value: "221" },
      { key: "381", value: "381" },
      { key: "248", value: "248" },
      { key: "232", value: "232" },
      { key: "65", value: "65" },
      { key: "252", value: "252" },
      { key: "94", value: "94" },
      { key: "268", value: "268" },
      { key: "27", value: "27" },
      { key: "249", value: "249" },
      { key: "211", value: "211" },
      { key: "46", value: "46" },
      { key: "41", value: "41" },
      { key: "597", value: "597" },
      { key: "66", value: "66" },
      { key: "886", value: "886" },
      { key: "992", value: "992" },
      { key: "246", value: "246" },
      { key: "670", value: "670" },
      { key: "228", value: "228" },
      { key: "690", value: "690" },
      { key: "676", value: "676" },
      { key: "1868", value: "1868" },
      { key: "216", value: "216" },
      { key: "993", value: "993" },
      { key: "90", value: "90" },
      { key: "688", value: "688" },
      { key: "380", value: "380" },
      { key: "256", value: "256" },
      { key: "598", value: "598" },
      { key: "998", value: "998" },
      { key: "678", value: "678" },
      { key: "379", value: "379" },
      { key: "58", value: "58" },
      { key: "84", value: "84" },
      { key: "681", value: "681" },
      { key: "967", value: "967" },
      { key: "253", value: "253" },
      { key: "260", value: "260" },
      { key: "263", value: "263" }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/helpers/country-dropdown-list.js